module.exports = __webpack_public_path__ + "static/media/classifiers.3fe7c343.svg";